import React from "react";
import { getValue } from "@utils/lodash";

function MenuActivitySvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        viewBox="0 0 24 24"
      >
        <defs>
          <clipPath id="clip-path9">
            <rect
              id="Rectangle_18183"
              data-name="Rectangle 18183"
              width="24"
              height="24"
              transform="translate(-16168 -8136)"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Mask_Group_291"
          data-name="Mask Group 291"
          transform="translate(16168 8136)"
          clip-path="url(#clip-path9)"
        >
          <path
            id="list_alt_FILL0_wght300_GRAD0_opsz24_1_"
            data-name="list_alt_FILL0_wght300_GRAD0_opsz24 (1)"
            d="M9.768-14.891a.9.9,0,0,0,.667-.269.908.908,0,0,0,.269-.668.9.9,0,0,0-.269-.667.908.908,0,0,0-.668-.269A.9.9,0,0,0,9.1-16.5a.908.908,0,0,0-.269.668.9.9,0,0,0,.269.667A.908.908,0,0,0,9.768-14.891Zm0-4.113a.9.9,0,0,0,.667-.269.908.908,0,0,0,.269-.668.9.9,0,0,0-.269-.667.908.908,0,0,0-.668-.269.9.9,0,0,0-.667.269.908.908,0,0,0-.269.668.9.9,0,0,0,.269.667A.908.908,0,0,0,9.768-19Zm0-4.113a.9.9,0,0,0,.667-.269.908.908,0,0,0,.269-.668.9.9,0,0,0-.269-.667.908.908,0,0,0-.668-.269.9.9,0,0,0-.667.269.908.908,0,0,0-.269.668.9.9,0,0,0,.269.667A.908.908,0,0,0,9.768-23.118Zm3.216,8.084h6.027v-1.588H12.984Zm0-4.113h6.027v-1.588H12.984Zm0-4.113h6.027v-1.588H12.984ZM6.855-10.941A1.848,1.848,0,0,1,5.5-11.5a1.848,1.848,0,0,1-.556-1.358V-27.027A1.848,1.848,0,0,1,5.5-28.385a1.848,1.848,0,0,1,1.358-.556H21.027a1.848,1.848,0,0,1,1.358.556,1.848,1.848,0,0,1,.556,1.358v14.172a1.848,1.848,0,0,1-.556,1.358,1.848,1.848,0,0,1-1.358.556Zm0-1.588H21.027a.311.311,0,0,0,.224-.1.311.311,0,0,0,.1-.224V-27.027a.311.311,0,0,0-.1-.224.311.311,0,0,0-.224-.1H6.855a.311.311,0,0,0-.224.1.311.311,0,0,0-.1.224v14.172a.311.311,0,0,0,.1.224A.311.311,0,0,0,6.855-12.529ZM6.529-27.353v0Z"
            transform="translate(-16169.941 -8104.059)"
            fill={
              getValue(props, `color`, "")
                ? getValue(props, `color`, "")
                : "#5f6368"
            }
          />
        </g>
      </svg>
    </div>
  );
}

export default MenuActivitySvgComponent;
